import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";

import Messages from '../../constants/Messages';
import AppRoutes from '../../constants/AppRoutes';

import Header from '../../components/header/header';
import FormField from '../../containers/form-field/form-field';
import Input from '../../components/form-elements/input';
import Button from '../../components/form-elements/button';
import Loader from '../../components/loader/loader';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import ErrorUtils from '../../utilities/error-utils';
import LoginValidations, { encryptData } from '../../utilities/login-validations';

import AuthenticationService from '../../services/authentication-service';
import { useAuth } from '../../hooks/useAuth';
import Modal from '../../containers/modals/modal';

const ResetPassword = () => {
    const navigate = useNavigate();
    const [modal, setModal] = useState(false);
    const { authLogout } = useAuth();

    const [loader, setLoader] = useState(false);
    const [currentPassword, setCurrentPassword] = useState();
    const [newPassword, setNewPassword] = useState();
    const [rePassword, setRePassword] = useState();
    const [validationErrors, setValidationErrors] = useState({
        currentPassword : null,
        newPassword: null,
        rePassword : null
    });

    /** ---------------------------------
     * Method : Current Password Change
     */
    const onCurrentPasswordChange = (e) => {
        setCurrentPassword(e.target.value);
    };

    /** ---------------------------------
     * Method : Current Password Change
     */
    const onNewPasswordChange = (e) => {
        setNewPassword(e.target.value);
    };

    /** ---------------------------------
     * Method : Current Password Change
     */
    const onRePasswordChange = (e) => {
        setRePassword(e.target.value);
    };

    /** ---------------------------------
     * Method : Change Password
     * 
     */
    const updatePassword = async () => {
        // client side validation
        const validateCurrentPasswordErrors = LoginValidations.validatePassword(currentPassword);
        const validateNewPasswordErrors = LoginValidations.validateNewPassword(newPassword);
        const validateRePasswordErrors = LoginValidations.validateConfirmPassword(newPassword, rePassword);
        setValidationErrors({
            currentPassword : validateCurrentPasswordErrors,
            newPassword : validateNewPasswordErrors,
            rePassword : validateRePasswordErrors
        });
        
        if(validateCurrentPasswordErrors === null && 
            validateNewPasswordErrors === null && 
            validateRePasswordErrors === null){
            setLoader(true);
            try{
                const { publicKey }  = await AuthenticationService.getPublicKey(); // Fetching the public key for encryption.
                const userDetails = await AuthenticationService.getUserDetails();
                const userCredentials = JSON.stringify({
                    email : userDetails.email,
                    currentPassword : currentPassword,
                    newPassword : newPassword
                })
                const encryptedUserCredentials = encryptData(publicKey,userCredentials); // Encrypting the user credentials before sending.
                const isSuccess = await AuthenticationService.updatePassword(encryptedUserCredentials);
                if(isSuccess) {
                    setModal(true);
                }
            } catch (error) {
                if(error.code === Messages.ERROR_CODES.INVALID_JWT.code) {
                    authLogout();
                    navigate(AppRoutes.LOGIN);
                } else {
                    toast.error(error.message);
                }
            }
            setLoader(false);
        }
    };

    /** ---------------------------------------------------
     * Method : logout
     * Description : To logout user from the app
     */
    const logout = async () => {
        await AuthenticationService.logout();
        authLogout();
        navigate(AppRoutes.LOGIN);
    }

    return (
        <div className='bg-gray-100'>
            <Header isPrevActive = {true} prevNavigationText = {Messages.SHOP.TITLE} prevPath = {AppRoutes.HOME}/>
            <div className="mx-auto max-w-lg p-8 h-screen h-screen">
                
                <h1 className='text-2xl font-bold'>{Messages.RESET_PASSWORD.PAGE_TITLE}</h1>
                <div className='text-xs p-4 rounded-lg bg-cyan-200 mt-4'>
                    <h3 className='font-bold mb-2'>{Messages.RESET_PASSWORD.PASSWORD_RULES.TITLE}</h3>
                    <ul className='list-disc pl-4'>
                        <li>{Messages.RESET_PASSWORD.PASSWORD_RULES.MIN_CHARACTER_LIMIT}</li>
                        <li>{Messages.RESET_PASSWORD.PASSWORD_RULES.MAX_CHARACTER_LIMIT}</li>
                        <li>{Messages.RESET_PASSWORD.PASSWORD_RULES.COMBINATION}</li>
                    </ul>
                </div>
                <div className='mt-5'>
                    <FormField label = {Messages.RESET_PASSWORD.FORM_FIELDS.CURRENT_PASSWORD.LABEL} labelClass = "text-sm"  error = {validationErrors.currentPassword}>
                        <Input type = "password" onChange = {onCurrentPasswordChange}/>
                    </FormField>
                    <FormField label = {Messages.RESET_PASSWORD.FORM_FIELDS.NEW_PASSWORD.LABEL} labelClass = "text-sm"  error = {validationErrors.newPassword}>
                        <Input type = "password" onChange = {onNewPasswordChange}/>
                    </FormField>
                    <FormField label = {Messages.RESET_PASSWORD.FORM_FIELDS.RE_PASSWORD.LABEL} labelClass = "text-sm"  error = {validationErrors.rePassword}>
                        <Input type = "password" onChange = {onRePasswordChange}/>
                    </FormField>
                    <FormField>
                        <Button size = "full" onClick = {updatePassword}>{Messages.RESET_PASSWORD.FORM_FIELDS.UPDATE_PASSWORD}</Button>
                    </FormField>
                </div>

                <Loader show = {loader} fullPage = {true} message = {Messages.LOGIN.SIGNING_YOU_IN}/>
                <ToastContainer/>
                <Modal
                    show = {modal} 
                    title = {Messages.RESET_PASSWORD.MODAL.PASSWORD_UPDATED.TITLE}
                    actionLabel = {Messages.RESET_PASSWORD.MODAL.PASSWORD_UPDATED.ACTIONS.LOGOUT}
                    actionCallback = {logout}
                >
                    {Messages.RESET_PASSWORD.MODAL.PASSWORD_UPDATED.MESSAGE}
                </Modal>
            </div>
        </div>
    )
}
export default ResetPassword;